<template>
  <div id="contenedor-main-estadisticas-consultas">
    <Estadisticas
    titulo="Estadisticas"
    :datosMostrar="datosMostrar"
    mostrarTablaProgramas/>
  </div>
</template>

<script>
import Estadisticas from '@/components/administracion/contratos/estadisticas/Main.vue';

export default {
  name: 'MainEstadisticasConsultas',
  components: {
    Estadisticas,
  },
  data() {
    return {
      datosMostrar: [
        'contatos',
        'enEjecucion',
        'sinAvFisico',
        'aTiempo',
        'atrasadas',
        'muyAtrasadas',
        'terminados',
        'rescindidos',
        'enObservacion',
        'terminacionAnticipada',
        'avanceProgramado',
        'avanceFisico',
        'avanceFinanciero',
      ],
    };
  },

};
</script>

<style>

</style>
